import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import AC from "../img/AC.png";
import Addma from "../img/Addma.png";
import Charactermatch from "../img/Charactermatch.png";
import ControllerRow from "../img/ControllerRow.png";
import ControllerRow2 from "../img/ControllerRow2.png";
import ControllerRow3 from "../img/ControllerRow3.png";
import ControllerRow4 from "../img/ControllerRow4.png";
import ControllerRow5 from "../img/ControllerRow5.png";
import Controllerrow6 from "../img/Controllerrow6.png";
import Fillblankanswers from "../img/Fillblankanswers.png";
import Fillblankanswers2 from "../img/Fillblankanswers2.png";
import Hitenter from "../img/Hitenter.png";
import HoverAC from "../img/HoverAC.png";
import integral1 from "../img/integral1.svg";
import Keyboardshortcuts1 from "../img/Keyboardshortcuts1.png";
import Keyboardshortcuts2 from "../img/Keyboardshortcuts2.png";
import MAgrade from "../img/MAgrade.png";
import Mathanswers1 from "../img/Mathanswers1.png";
import Mathanswers3 from "../img/Mathanswers3.png";
import Mathanswers4 from "../img/Mathanswers4.png";
import Mathanswers5 from "../img/Mathanswers5.png";
import Mathanswers7 from "../img/Mathanswers7.png";
import Mathanswers8 from "../img/Mathanswers8.png";
import Multipleacceptableanswers from "../img/Multipleacceptableanswers.png";
import MultipleanswersRP from "../img/MultipleanswersRP.png";
import Multiplechoiceanswers from "../img/Multiplechoiceanswers.png";
import Multiplecopiesadded from "../img/Multiplecopiesadded.png";
import Numericanswers from "../img/Numericanswers.png";
import Numericanswers10 from "../img/Numericanswers10.png";
import Numericanswers11 from "../img/Numericanswers11.png";
import Numericanswers12 from "../img/Numericanswers12.png";
import Numericanswers13 from "../img/Numericanswers13.png";
import Numericanswers14 from "../img/Numericanswers14.png";
import Numericanswers2 from "../img/Numericanswers2.png";
import Numericanswers3 from "../img/Numericanswers3.png";
import Numericanswers4 from "../img/Numericanswers4.png";
import Numericanswers5 from "../img/Numericanswers5.png";
import Numericanswers6 from "../img/Numericanswers6.png";
import Numericanswers7 from "../img/Numericanswers7.png";
import Numericanswers8 from "../img/Numericanswers8.png";
import Numericanswers9 from "../img/Numericanswers9.png";
import Savingonlinepaper from "../img/Savingonlinepaper.png";
import TipsCreatepage from "../img/TipsCreatepage.png";
import math56 from "../img/math56.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",
    "& a": {
      color: "#4381b5",
    },
    "& h2": {
      marginBottom: "30px",
    },
    "& h4": {
      margin: "30px 0px",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",

      // transition: "transform .2s",
      // "&:hover": {
      //   transform: "scale(1.3)",
      // },
    },
    "& ul": { marginLeft: "20px" },
    "& li": {
      marginLeft: "20px",
    },
  },
  detailsgrid: {
    height: "40px",
  },
  detailsgridline: {
    display: "inline-block",
    margin: "auto 30px",
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "300px",
    width: "80%",
    margin: "15px 20px 20px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  highlighted: {
    backgroundColor: "#d8d2e7",
    width: "max-content",
    borderLeft: "5px solid #d8d2e7",
    borderRight: "5px solid #d8d2e7",
  },
}));

function NumericAnswers() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Numeric answers
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#whatarenumeric">What are Numeric answers?</a>
          <br />
          <br />
          <a href="#howaregraded">How are Numeric answers graded?</a>
          <br />
          <br />
          <a href="#inputtingnumeric">Inputting Numeric answers</a>
          <br />
          <br />
          <a href="#tolerancerange">Tolerance range</a>
          <br />
          <br />
          <a href="#unitsu">Units (U)</a>
          <br />
          <br />
          <a href="#significantfigures">Significant figures (SF)</a>
          <br />
          <br />
          <a href="#scientificnotation">Scientific notation (SN)</a>
          <br />
          <br />
          <a href="#howareanswers">
            How are answers with U or SF shown on the results page?
          </a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="whatarenumeric"
        >
          What are Numeric answers?:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers2}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          Numeric answers must have an actual numeric value.
          <br />
          <br />
          For example, these answers are allowed:
        </Typography>
        <img
          style={{ maxWidth: "800px", boxShadow: "none" }}
          className={classes.imgSize}
          src={Numericanswers}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          but these are not:
        </Typography>
        <img
          style={{ maxWidth: "800px", boxShadow: "none" }}
          className={classes.imgSize}
          src={Numericanswers13}
          alt="Numeric"
        />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howaregraded"
        >
          How are Numeric answers graded?:
        </Typography>

        <Typography className={classes.details} variant="body2">
          SwiftGrade converts both your answer and the student’s answer to a
          decimal and then compares them. For example, if your answer was 10,
          this is how SwiftGrade would grade various student answers:
          <br />
          <br />
        </Typography>
        <Grid container>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 1: <span style={{ color: "green" }}>10</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 2: <span style={{ color: "green" }}>20/2</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 3: <span style={{ color: "red" }}>46</span>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
          </Grid>
        </Grid>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="inputtingnumeric"
        >
          Inputting Numeric answers:
        </Typography>

        <Typography className={classes.details} variant="body2">
          Inputting Numeric answers is modeled after{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://www.desmos.com/."
          >
            desmos.com.
          </a>
          <br />
          <br />
          You can input answers by using either our:
          <ul>
            <li>
              <Link
                className={classes.hyperlink}
                style={{ fontWeight: "700" }}
                to="/help-topics/create-answer-key-topics/keyboard-shortcuts"
              >
                Keyboard shortcuts:
              </Link>{" "}
              For example, if you type ‘pi’ you will get π.
            </li>
            <li
              style={{
                listStyleType: "none",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              <Typography>or</Typography>
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>Virtual keyboard: </span>This
              appears every time you click into a Numeric answer field:
            </li>
            <img
              style={{ maxWidth: "800px" }}
              className={classes.imgSize}
              src={Numericanswers9}
              alt="Numeric"
            />
            We recommend using{" "}
            <Link
              className={classes.hyperlink}
              to="/help-topics/create-answer-key-topics/keyboard-shortcuts"
            >
              keyboard shortcuts
            </Link>{" "}
            as they are much faster.
          </ul>
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="tolerancerange"
        >
          Tolerance range:
        </Typography>
        <Typography className={classes.details} variant="body2">
          Tolerance allows you to set the acceptable range for an answer.
          <br />
          <br />
          For example, if the tolerance is 0%:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers14}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          then only answers that are equivalent to exactly 100 will be marked
          correct.
          <br />
          <br />
          However, if the tolerance is ±2%:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers3}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          any answer between 98-102 will be marked correct.
        </Typography>
        <Typography className={classes.highlighted} variant="h6" id="unitsu">
          Units (U):
        </Typography>
        <Typography className={classes.details} variant="body2">
          Click the ‘U’ toggle to add units to your answer.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers4}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          You can now give a separate mark for the correct answer and units.
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers5}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          Note that whenever you click into the units field, a virtual keyboard
          pops up. However, we recommend simply typing using our{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/create-answer-key-topics/keyboard-shortcuts"
          >
            Keyboard shortcuts.
          </Link>{" "}
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers8}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          When units is on, this is how SwiftGrade would grade various student
          answers:
          <br />
          <br />
          Answer key:{" "}
          <span style={{ fontWeight: "700" }}>
            20 m/s<sup>2</sup>
          </span>
          <br />
          <br />
        </Typography>
        <Grid container>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 1: <span style={{ color: "green" }}>20</span>
              <span style={{ color: "red" }}> km</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 2: <span style={{ color: "red" }}>100</span>
              <span style={{ color: "green" }}>
                {" "}
                m/s<sup>2</sup>
              </span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 3:
              <span style={{ color: "green" }}>
                {" "}
                20 m/s<sup>2</sup>
              </span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 4: <span style={{ color: "red" }}> 100 km </span>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0.75/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0.25/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
          </Grid>
        </Grid>
        <Typography className={classes.details} variant="body2">
          Note that when grading units, SwiftGrade character matches your units
          to the student’s units.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="significantfigures"
        >
          Significant figures (SF):
        </Typography>
        <Typography className={classes.details} variant="body2">
          Click the ‘SF’ toggle to add Sig figs to your answer:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers7}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          You can now give a separate mark for the answer and sig figs:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers12}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          As you type your answer, the number of sig figs will automatically
          change.
          <br />
          <br />
          When Sig figs is on, this is how SwiftGrade would grade various
          student answers:
          <br />
          <br />
          Answer key: <span style={{ fontWeight: "700" }}>1.4300</span>
          <br />
          <br />
        </Typography>
        <Grid container>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 1: <span style={{ color: "#bf9000" }}> 1.43</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 2: <span style={{ color: "#bf9000" }}> 1.9600</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 3:
              <span style={{ color: "green" }}> 1.4300</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 4: <span style={{ color: "red" }}> 1.96 </span>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0.75/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0.25/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
          </Grid>
        </Grid>
        <Typography className={classes.details} variant="body2">
          Note that for Sig figs, your answer must be in decimal format. For
          example, you can’t have Sig figs on for an answer of ½.
          <br />
          <br />
          Note if your answer has Sig figs on, but the student’s answer is a
          non-decimal, they will get the Sig figs portion incorrect.
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="scientificnotation"
        >
          Scientific notation (SN):
        </Typography>

        <Typography className={classes.details} variant="body2">
          Click the ‘SN’ toggle to add scientific notation to your answer.
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers6}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          This saves you from typing X10^ everytime.
          <br />
          <br />
          This is especially helpful if you have multiple answers with
          scientific notation as you can turn this toggle on and then add
          multiple copies at once using the controller row.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howareanswers"
        >
          How are answers with U or SF shown on the results page?
        </Typography>
        <Typography className={classes.details} variant="body2">
          If U or SF are on, there is an arrow in the marks column of the
          results tab:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers10}
          alt="Numeric"
        />
        <Typography className={classes.details} variant="body2">
          Clicking this arrow expands the mark breakdown for the student’s
          answer.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Numericanswers11}
          alt="Numeric"
        />
      </div>
    </div>
  );
}

function FillBlanksAnswers() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Fill in the blank answers
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#whatarefill">What are Fill in the blank answers?</a>
          <br />
          <br />
          <a href="#howarefill">How are Fill in the blank answers graded?</a>
          <br />
          <br />
          <a href="#autocorrectfill">Auto-correct (AC)</a>
          <br />
          <br />
          <a href="#howisautocorrect">
            How is Auto-correct (AC) shown on the results page?
          </a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="whatarefill"
        >
          What are Fill in the blank answers?
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Fillblankanswers}
          alt="Fill blank answers"
        />
        <Typography className={classes.details} variant="body2">
          Fill in the blank answers are any short, finite answers, usually
          between 1 to 3 words.
          <br />
          <br />
          Some examples are:
          <br />
          <br />
        </Typography>

        <Typography className={classes.detailsgridline} variant="body2">
          Vector
        </Typography>
        <Typography className={classes.detailsgridline} variant="body2">
          112 Penn Street
        </Typography>
        <Typography className={classes.detailsgridline} variant="body2">
          Cell Membrane
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howarefill"
        >
          How are Fill in the blank answers graded?
        </Typography>

        <Typography className={classes.details} variant="body2">
          Student answers are character matched against your answer. Case and
          spacing does not matter. For example, if your answer was{" "}
          <span style={{ fontWeight: "700" }}>Ionic Compound</span>, this is how
          SwiftGrade would grade various student answers:
          <br />
          <br />
        </Typography>
        <Grid container>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 1: <span style={{ color: "green" }}> IONIC COMPOUND</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 2:{" "}
              <span style={{ color: "green" }}> Io nic Compound</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 3:
              <span style={{ color: "red" }}> Ionik Compound </span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 4:{" "}
              <span style={{ color: "red" }}> Covalent compound</span>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
          </Grid>
        </Grid>

        <Typography style={{ fontStyle: "italic" }} variant="body2">
          Note that if Auto-correct (AC) was on, student 3 would be marked
          correct.
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="autocorrectfill"
        >
          Auto-correct (AC):
        </Typography>

        <Typography className={classes.details} variant="body2">
          Click the ‘AC’ button to toggle ‘Auto-correct’ on and off. By{" "}
          <span style={{ fontWeight: "700" }}>default,</span> it is on:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Fillblankanswers2}
          alt="Fill in blank"
        />
        <Typography className={classes.details} variant="body2">
          When on, SwiftGrade will accept student answers with minor spelling
          mistakes.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howisautocorrect"
        >
          How is Auto-correct (AC) shown on the results page?
        </Typography>

        <Typography className={classes.details} variant="body2">
          On the results page, if the student's answer was auto-corrected there
          will be an AC icon next to the student’s answer:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={AC}
          alt="Auto correct"
        />
        <Typography className={classes.details} variant="body2">
          If you hover on this icon, it will tell you how the student’s answer
          was auto corrected:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={HoverAC}
          alt="Hover Auto correct"
        />
      </div>
    </div>
  );
}

function MathAnswers() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Math answers
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#whataremath">What are Math answers?</a>
          <br />
          <br />
          <a href="#howaremath">How are Math answers graded?</a>
          <br />
          <br />
          <a href="#inputtingmath">Inputting Math answers</a>
          <br />
          <br />
          <a href="#inputtingmathunits">Inputting units (U)</a>
          <br />
          <br />
          <a href="#howaremath">
            How are Math answers with U shown on the results page?
          </a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="whataremath"
        >
          What are Math answers?
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Mathanswers1}
          alt="Math answers"
        />
        <Typography className={classes.details} variant="body2">
          The Math answer type covers most answers that are math expressions,
          variables, and formulas.
          <br />
          <br />
          For example, these answers are allowed:
          <br />
          <br />
        </Typography>
        <Grid container alignItems="center" justifyContent="space-around">
          <Typography className={classes.details} variant="body2">
            y= 2x<sup>2</sup>+4x+6
          </Typography>
          <Typography className={classes.details} variant="body2">
            <img
              alt="integral"
              src={integral1}
              style={{ height: "100%", boxShadow: "none" }}
            />
          </Typography>
          <Typography className={classes.details} variant="body2">
            y = sin2x
          </Typography>
          <Typography className={classes.details} variant="body2">
            |x|
          </Typography>
          <Typography className={classes.details} variant="body2">
            log (5+2x) = 3
          </Typography>
          <Typography className={classes.details} variant="body2">
            <img
              alt="integral"
              src={math56}
              style={{ width: "120px", boxShadow: "none" }}
            />
          </Typography>
          <br />
          <br />
        </Grid>

        <Typography className={classes.details} variant="body2">
          Important{" "}
          <span style={{ fontStyle: "italic" }}>
            *Note that if your answer has a numeric value, please use the
            Numeric answer type.
          </span>
        </Typography>

        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howaremath"
        >
          How are Math answers graded?
        </Typography>

        <Typography className={classes.details} variant="body2">
          Depending on your answer, SwiftGrade will grade either by equivalence,
          or by character matching.
          <br />
          <br />
        </Typography>
        <Typography className={classes.details} variant="body2">
          <span style={{ fontWeight: "700" }}>Grading by equivalence:</span>
          <br />
          <br />
          For most answers, SwiftGrade looks for equivalence between your answer
          and the student’s answer. For example, if your answer was y = 2x, this
          is how SwiftGrade would grade various student answers using
          equivalence:
          <br />
          <br />
        </Typography>
        <Grid container>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 1: <span style={{ color: "green" }}> x = y/2</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 2: <span style={{ color: "green" }}> 2y = 4x </span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 3:
              <span style={{ color: "red" }}> y = 2x+12</span>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
          </Grid>
        </Grid>

        <Typography className={classes.details} variant="body2">
          <span style={{ fontWeight: "700" }}>
            Grading by character matching:
          </span>
          <br />
          <br />
          Unfortunately, for certain types of answers, SwiftGrade cannot find
          equivalence and thus those answers will be character matched.
          <br />
          <br />
          This means that only if the student writes their answer in the exact
          same format as your answer will they be marked correct.
          <br />
          <br />
          If an answer will be graded using character matching, this ‘warning’
          icon will appear next to your answer:
          <img
            style={{ maxWidth: "800px" }}
            className={classes.imgSize}
            src={Charactermatch}
            alt="character match"
          />
          If your answer was{" "}
          <span style={{ fontWeight: "700" }}>f(2) = 20 </span>, then only
          students who wrote{" "}
          <span style={{ fontWeight: "700" }}>exactly f(2) = 20</span> would be
          marked correct:
          <br />
          <br />
        </Typography>
        <Grid container>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 1: <span style={{ color: "green" }}> f(2) = 20</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 2: <span style={{ color: "red" }}> 20 = f(2) </span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 3:
              <span style={{ color: "red" }}> f(2) = (10+10)</span>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
          </Grid>
        </Grid>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="inputtingmath"
        >
          Inputting Math answers:
        </Typography>
        <Typography className={classes.details} variant="body2">
          Inputting Math answers is modeled after{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://www.desmos.com/."
          >
            desmos.com.
          </a>
          <br />
          <br />
          You can input answers by either using our:
        </Typography>
        <ul>
          <li>
            <Typography className={classes.details} variant="body2">
              <Link
                className={classes.hyperlink}
                style={{ fontWeight: "700" }}
                to="/help-topics/create-answer-key-topics/keyboard-shortcuts"
              >
                Keyboard shortcuts:
              </Link>{" "}
              For example, if you type ‘pi’ you will get π.
            </Typography>
          </li>
          <li
            style={{
              listStyleType: "none",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <Typography>or</Typography>
          </li>
          <li>
            <Typography className={classes.details} variant="body2">
              <span style={{ fontWeight: "700" }}>Virtual keyboard:</span> This
              appears every time you click into a Math answer field.
            </Typography>
          </li>
        </ul>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Mathanswers8}
          alt="Math"
        />
        <Typography className={classes.details} variant="body2">
          We recommend using{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/create-answer-key-topics/keyboard-shortcuts"
          >
            keyboard shortcuts
          </Link>{" "}
          as they are much faster.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="inputtingmathunits"
        >
          Units (U):
        </Typography>
        <Typography className={classes.details} variant="body2">
          Click the ‘U’ toggle to add units to your answer.
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Mathanswers3}
          alt="Math"
        />
        <Typography className={classes.details} variant="body2">
          You can now give a separate mark for the correct answer and units.{" "}
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Mathanswers4}
          alt="Math"
        />
        <Typography className={classes.details} variant="body2">
          Note that whenever you click into the units field, a virtual keyboard
          pops up. However, we recommend simply typing using our{" "}
          <Link
            className={classes.hyperlink}
            to="/help-topics/create-answer-key-topics/keyboard-shortcuts"
          >
            keyboard shortcuts.
          </Link>
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Mathanswers5}
          alt="Math"
        />
        <Typography className={classes.details} variant="body2">
          When units is on, this is how SwiftGrade would grade various student
          answers:
          <br />
          <br />
          Answer key:{" "}
          <span style={{ fontWeight: "700" }}>
            4 m<sup>2</sup>
          </span>
          <br />
          <br />
        </Typography>
        <Grid container>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 1: <span style={{ color: "green" }}> 4</span>
              <span style={{ color: "red" }}> L</span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 2: <span style={{ color: "red" }}> 16</span>
              <span style={{ color: "green" }}>
                {" "}
                m<sup>2</sup>
              </span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 3:
              <span style={{ color: "green" }}>
                {" "}
                8/2 m<sup>2</sup>
              </span>
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Student 4: <span style={{ color: "red" }}> 100 L </span>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0.75/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0.25/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 1/1
            </Typography>
            <Typography className={classes.detailsgrid} variant="body2">
              Mark: 0/1
            </Typography>
          </Grid>
        </Grid>
        <Typography className={classes.details} variant="body2">
          Note that when grading units, SwiftGrade character matches your units
          to the student’s units.
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howaremath"
        >
          How are Math answers with U shown on the results page?
        </Typography>
        <Typography className={classes.details} variant="body2">
          If U or SF are on, there is an arrow in the marks column of the
          results tab:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Mathanswers7}
          alt="Math"
        />
        <Typography className={classes.details} variant="body2">
          Clicking this shows the mark breakdown for the student’s answer.
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Mathanswers7}
          alt="Math"
        />
      </div>
    </div>
  );
}
function MultipleChoiceAnswers() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Multiple choice answers
        </Typography>
      </div>
      <div display="block">
        <img
          style={{ maxWidth: "800px", marginTop: "90px" }}
          className={classes.imgSize}
          src={Multiplechoiceanswers}
          alt="Multiple Choice"
        />
        <Typography className={classes.details} variant="body2">
          SwiftGrade offers three different variations of multiple choice
          answers:
          <ul>
            <li>
              <span style={{ fontWeight: "700" }}>Multiple choice:</span> One
              letter is selected per answer
              <br />
              <br />
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>Multiple selection:</span>{" "}
              Multiple letters are selected per answer <br />
              <br />
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>True or false:</span> A =
              true, B = false <br />
              <br />
            </li>
          </ul>
          SwiftGrade grades multiple choice answers by seeing if the selected
          letters of the teacher’s answer match the selected letters of the
          student’s answer.
          <br />
          <br />
          Note that the SwiftGrade iOS and Android app only allows you to create
          multiple choice answers. To add other answer types you must use our
          website.
        </Typography>
      </div>
    </div>
  );
}

function DifferentAnswerTopics() {
  const { path } = useRouteMatch();
  useEffect(() => {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");

    script1.src = "https://fast.wistia.com/embed/medias/2sukiwpt2k.jsonp";
    script1.async = true;

    script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }, []);

  return (
    <>
      <Switch>
        <Route path={`${path}/numeric-answers`}>
          <NumericAnswers />
        </Route>
        <Route path={`${path}/fill-in-the-blank-answers`}>
          <FillBlanksAnswers />
        </Route>
        <Route path={`${path}/math-answers`}>
          <MathAnswers />
        </Route>
        <Route path={`${path}/multiple-choice-answers`}>
          <MultipleChoiceAnswers />
        </Route>
      </Switch>
    </>
  );
}

export default DifferentAnswerTopics;
